// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Switch,
  AlertTitle,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";

import ApiConfig from "apiConfig";

import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";
import P2PRequestHeader from "./header";

function CreateOffer() {
  const pageTitle = "New Request";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  // const [exchangeRates, setExchangeRates] = useState([]);
  const [digitalWallets, setDigitalWallets] = useState([]);
  const [selectedDigitalWallet, setSelectedDigitalWallet] = useState(null);
  const [selectedDigitalCurrency, setSelectedDigitalCurrency] = useState(null);
  const [destinationDetails, setDestinationDetails] = useState({});
  const [digitalCurrenciesMain, setDigitalCurrenciesMain] = useState([]);
  const [digitalCurrencies, setDigitalCurrencies] = useState([]);
  const [balanceCurrencies, setBalanceCurrencies] = useState([]);
  // const [feeObjects, setFeeObjects] = useState({});
  const [calculated, setCalculated] = useState(false);
  // const [commercialLine, setCommercialLine] = useState("");
  // const [feeLine, setFeeLine] = useState("");
  const [commission, setCommission] = useState(null);
  const [escrowFee, setEscrowFee] = useState(null);
  const [finalAmount, setFinalAmount] = useState(null);

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);
  const [fiatLabel, setFiatLabel] = useState("");
  const [walletLabel, setWalletLabel] = useState("Payment Method");

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("ewallets/offers/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setDigitalWallets(result.data.data.wallets);
            setDigitalCurrenciesMain(result.data.data.digital_currencies);
            setBalanceCurrencies(result.data.data.fiat_currencies);
            // setFeeObjects(result.data.data.fees);
            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("dw-create")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again later.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const [digitalCurrency, setDigitalCurrency] = useState("");
  const [balanceCurrency, setBalanceCurrency] = useState("");
  const [state, setState] = useState({});
  const {
    digitalWallet = null,
    amount = null,
    minAmount = null,
    exchangeRate = null,
    orderSide = null,
    allowPartials = true,
  } = state;

  const handleSwitchChange = (event) => {
    setState({ ...state, allowPartials: event.target.checked });
  };

  // function calculateFee(digitalWalletCode, trxAmount) {
  //   const feeObject = feeObjects[digitalWalletCode];
  //   let tFee = feeObject.fee;
  //   if (feeObject.is_percentage) {
  //     tFee = trxAmount * feeObject.fee;
  //     if (feeObject.minimum > 0) {
  //       tFee = feeObject.minimum > tFee ? feeObject.minimum : tFee;
  //     }

  //     if (feeObject.maximum > 0) {
  //       tFee = feeObject.maximum < tFee ? feeObject.maximum : tFee;
  //     }

  //     tFee += feeObject.mandatory_fee;
  //   }

  //   let cDiscount = feeObject.discount;
  //   if (feeObject.is_discount_percentage) {
  //     cDiscount = tFee * feeObject.discount;
  //   }

  //   tFee -= cDiscount;
  //   return tFee / 100;
  // }

  // function showCommercials() {
  //   if (digitalCurrency === null || fiatCurrency === null || digitalWallet == null) {
  //     return;
  //   }

  //   if (orderSide === null) {
  //     return;
  //   }

  //   if (amount === null) {
  //     return;
  //   }

  //   let cLine = "";
  //   const dir = orderSide === "BUY" ? "Pay" : "Get";
  //   const fee = calculateFee(selectedDigitalWallet.code, amount * 100); // amount * 0.025;
  //   const amt = orderSide === "BUY" ? parseFloat(amount, 10) + fee : amount - fee;
  //   const fAmt = (amt * exchangeRate).toLocaleString("en-US", {
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   });
  //   cLine = `You ${dir}: ${fiatCurrency} ${fAmt}`;
  //   const feeL = `Fee: ${fiatCurrency} ${(fee * exchangeRate).toLocaleString("en-US", {
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   })}`;

  //   setCommercialLine(cLine);
  //   setFeeLine(feeL);
  //   setCalculated(true);
  // }

  async function calculateFee(digitalWalletCode, trxAmount) {
    const rate = balanceCurrency === digitalCurrency ? 1.0 : exchangeRate;
    const params = {
      amount: trxAmount * selectedDigitalCurrency.multiplier,
      digital_wallet: digitalWalletCode,
      side: orderSide,
      exchange_rate: rate * selectedDigitalCurrency.multiplier,
    };
    // console.log(params);

    setShowLoading(true);
    const json = JSON.stringify(params);
    await axios
      .post("ewallets/offers/calculate.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setEscrowFee(response.data.data.escrow_fee);
          setCommission(response.data.data.commission);
          setFinalAmount(response.data.data.transaction_amount);
          setCalculated(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
        setShowLoading(false);
      });
  }

  const handleInputChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
    setCalculated(false);
  };

  function handleWalletChange(value) {
    setState({ ...state, digitalWallet: value });
    setDigitalCurrencies(digitalCurrenciesMain[value]);
    setCalculated(false);
    setDestinationDetails({});

    digitalWallets.forEach((item) => {
      if (item.code === value) {
        setSelectedDigitalWallet(item);
      }
    });
  }

  function handleDigitalCurrencyChange(value) {
    setDigitalCurrency(value);

    digitalCurrencies.forEach((item) => {
      if (item.currency_code === value) {
        setSelectedDigitalCurrency(item);
      }
    });
  }

  useEffect(() => {
    setCalculated(false);
    if (digitalCurrency === "" || balanceCurrency === "") {
      return;
    }

    if (digitalCurrency === balanceCurrency) {
      setState({ ...state, exchangeRate: "1.00" });
    } else {
      setState({ ...state, exchangeRate: null });
    }
  }, [digitalCurrency, balanceCurrency]);

  useEffect(() => {
    if (orderSide === "BUY") {
      setFiatLabel("From My");
      setWalletLabel("To");
    } else if (orderSide === "SELL") {
      setFiatLabel("To My");
      setWalletLabel("From");
    }
  }, [orderSide]);

  const postData = async (params) => {
    setShowLoading(true);
    const json = JSON.stringify(params);
    await axios
      .post("ewallets/offers/create.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          navigate(`/p2p/ewallets/my-requests/${response.data.data.offer.reference}`);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
        setShowLoading(false);
      });
  };

  const handleSubmit = () => {
    if (digitalWallet === null) {
      setSeverity("error");
      setErrMsg("Please select a digital wallet");
      setOpen(true);
      return;
    }

    if (digitalCurrency === null || digitalCurrency === "") {
      setSeverity("error");
      setErrMsg("Please select a wallet currency");
      setOpen(true);
      return;
    }

    if (balanceCurrency === null || balanceCurrency === "") {
      setSeverity("error");
      setErrMsg("Please select a destination currency");
      setOpen(true);
      return;
    }

    if (balanceCurrency === digitalCurrency) {
      setState({ ...state, exchangeRate: "1.00" });
    }

    if (orderSide === null) {
      setSeverity("error");
      setErrMsg("Select a side. Are you buying or selling?");
      setOpen(true);
      return;
    }

    if (amount === null || amount <= 0) {
      setSeverity("error");
      setErrMsg("Please enter a valid amount.");
      setOpen(true);
      return;
    }

    if (exchangeRate === null || exchangeRate <= 0) {
      setSeverity("error");
      setErrMsg("Please set a valid exchange rate");
      setOpen(true);
      return;
    }

    if (allowPartials) {
      if (minAmount <= 0) {
        setSeverity("error");
        setErrMsg("Please enter a valid minimum amount");
        setOpen(true);
        return;
      }
    }

    if (orderSide === "BUY") {
      if (destinationDetails === null || destinationDetails.length < 1) {
        setSeverity("error");
        setErrMsg(`Please provide your ${selectedDigitalWallet.title} details.`);
        setOpen(true);
        return;
      }

      const passed = selectedDigitalWallet.parameters.every((param) => {
        if (!(param.key in destinationDetails)) {
          setSeverity("error");
          setErrMsg(`Your ${selectedDigitalWallet.title} ${param.display_name} is required`);
          setOpen(true);
          return false;
        }

        return true;
      });

      if (!passed) {
        return;
      }
    }

    if (!calculated) {
      calculateFee(digitalWallet, amount);
      return;
    }

    const params = {
      digital_wallet: digitalWallet,
      digital_currency: digitalCurrency,
      fiat_currency: balanceCurrency,
      side: orderSide,
      amount: amount * selectedDigitalCurrency.multiplier,
      min_transaction_amount: allowPartials
        ? minAmount * selectedDigitalCurrency.multiplier
        : amount * selectedDigitalCurrency.multiplier,
      allow_partial_fill: allowPartials,
      exchange_rate:
        (balanceCurrency === digitalCurrency ? 1.0 : exchangeRate) *
        selectedDigitalCurrency.multiplier,
      destination: destinationDetails,
    };

    // console.log(params);
    postData(params);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <P2PRequestHeader />
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        New Request
                      </MDTypography>
                      <MDBox mt={5}>
                        <MDBox mb={3}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>I Want To</InputLabel>
                                <Select
                                  label="Buy/Sell"
                                  defaultValue="SELL"
                                  name="orderSide"
                                  sx={{ padding: "10px", paddingLeft: "3px" }}
                                  onChange={handleInputChange}
                                  value={orderSide || ""}
                                >
                                  <MenuItem value="BUY">Send Funds</MenuItem>
                                  <MenuItem value="SELL">Withdraw Funds</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>{walletLabel}</InputLabel>
                                <Select
                                  label={walletLabel}
                                  onChange={(e) => handleWalletChange(e.target.value)}
                                  sx={{ padding: "10px", paddingLeft: "3px" }}
                                  value={digitalWallet || ""}
                                >
                                  {
                                    // --> Notice below changes
                                    digitalWallets.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      digitalWallets.map((record) => (
                                        <MenuItem value={record.code}>
                                          <MDBox
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="left"
                                          >
                                            <img
                                              alt=""
                                              src={`${ApiConfig.api_media_url}${record.logo}`}
                                              width="20"
                                              mr={3}
                                            />
                                            <MDBox ml={2}>{record.title}</MDBox>
                                          </MDBox>
                                        </MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox mt={4}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Currency</InputLabel>
                                <Select
                                  label="Currency"
                                  onChange={(e) => handleDigitalCurrencyChange(e.target.value)}
                                  sx={{ padding: "10px", paddingLeft: "3px" }}
                                  value={digitalCurrency || ""}
                                >
                                  {
                                    // --> Notice below changes
                                    digitalCurrencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      digitalCurrencies.map((record) => (
                                        <MenuItem value={record.currency_code}>
                                          {record.currency_code}
                                        </MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>{fiatLabel}</InputLabel>
                                <Select
                                  label={fiatLabel}
                                  defaultValue="NGN"
                                  name="balanceCurrency"
                                  sx={{ padding: "10px", paddingLeft: "3px" }}
                                  onChange={(e) => setBalanceCurrency(e.target.value)}
                                  value={balanceCurrency || ""}
                                >
                                  {
                                    // --> Notice below changes
                                    balanceCurrencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      balanceCurrencies.map((record) => (
                                        <MenuItem value={record.currency_code}>
                                          {record.currency_code} Balance
                                        </MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox mt={4} mb={3}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                value={amount || ""}
                                onChange={handleInputChange}
                                name="amount"
                                label={`${digitalCurrency} Amount`}
                                sx={{ minWidth: 120, width: "100%" }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                mb={3}
                                name="exchangeRate"
                                label={`Exchange Rate (${balanceCurrency})`}
                                sx={{ minWidth: 120, width: "100%" }}
                                value={exchangeRate || ""}
                                onChange={handleInputChange}
                              />
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mt={1}
                          lineHeight={1}
                        >
                          <MDTypography variant="h6">
                            <small>Allow partial fill?</small>
                          </MDTypography>

                          <Switch
                            defaultChecked
                            checked={allowPartials}
                            onChange={handleSwitchChange}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </MDBox>
                        <MDBox mt={2}>
                          <MDInput
                            disabled={!allowPartials}
                            name="minAmount"
                            label={`${digitalCurrency} Minimum Amount`}
                            sx={{ minWidth: 120, width: "100%" }}
                            value={minAmount || ""}
                            onChange={handleInputChange}
                          />
                        </MDBox>
                        {selectedDigitalWallet !== null && orderSide === "BUY" ? (
                          <MDBox mt={5}>
                            <MDTypography variant="h6">
                              <small>
                                Enter your {selectedDigitalWallet.title} details where funds will be
                                delivered to.
                              </small>
                            </MDTypography>
                            {selectedDigitalWallet.parameters.map((param) => (
                              <MDBox mt={2}>
                                <MDInput
                                  name={param.key}
                                  label={param.display_name}
                                  sx={{ minWidth: 120, width: "100%" }}
                                  // value={destinationDetails[param.key] || ""}
                                  onChange={(e) => {
                                    destinationDetails[param.key] = e.target.value;
                                    setDestinationDetails(destinationDetails);
                                  }}
                                />
                              </MDBox>
                            ))}
                          </MDBox>
                        ) : (
                          <> </>
                        )}

                        {calculated ? (
                          <MDBox mt={5}>
                            <Alert severity="info" sx={{ width: "100%" }}>
                              <MDTypography variant="h6" fontWeight="light">
                                Escrow Fee:{" "}
                                <b>
                                  {balanceCurrency}&nbsp;
                                  {(escrowFee / 100).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </b>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                Peer Commission:{" "}
                                <b>
                                  {balanceCurrency}&nbsp;
                                  {(commission / 100).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </b>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                You {orderSide === "BUY" ? "Pay" : "Get"}:{" "}
                                <b>
                                  {balanceCurrency}&nbsp;
                                  {(finalAmount / 100).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </b>
                              </MDTypography>
                            </Alert>
                          </MDBox>
                        ) : (
                          <> </>
                        )}
                        <MDBox mt={5}>
                          <MDButton
                            variant="contained"
                            color="info"
                            sx={{ width: "100%" }}
                            onClick={handleSubmit}
                          >
                            Send Request
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox sx={{ marginBottom: "35px" }}>
                  <Card>
                    <MDBox p={0}>
                      <Alert severity="info" sx={{ width: "100%" }}>
                        <AlertTitle>Help Tips</AlertTitle>
                        {/* <p>
                          <b>Wallet Currency</b> can be any supported currency in your digital
                          wallet you wish to buy or sell.
                        </p>
                        <br />
                        <p>
                          <b>Alero Balance</b> Select your balance where funds will be received into
                          or paid from.
                        </p>
                        <br /> */}
                        <p>
                          <b>Exchange rate</b> Enter an amount in your selected balance currency you
                          wish to exchange at.
                        </p>
                        <br />
                        <p>
                          <b>Partial Fill</b> let&apos;s your request get filled by different people
                          with different amounts. Disabling this will limit your request to only
                          those that exactly match your request amount.
                        </p>
                        <br />
                        <p>
                          <b>Minimum amount</b> applies only for requests with partial fill enabled.
                          Set the minimum amount you are willing to exchange with others.
                        </p>
                      </Alert>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CreateOffer;
